import React from "react";
import Spinner from "../../../components/Spinner/Spinner";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Buttons from "../../../components/Buttons/Buttons";
import HPBasicInfoFields from "../HPForm/HPBasicInfoFields";
import DeviceAssignmentSection from "../HPForm/DeviceAssignmentSection";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import ErrorAlert from "../../../components/ErrorAlert/ErrorAlert";
import HPInfoView from "./HPInfoView";

const HPProfileTab = ({
  isEditingProfile,
  setIsEditingProfile,
  hpFormProps,
  onDeleteHP,
}) => {
  const {
    errors,
    formData,
    messages,
    openConfirmModal,
    openResultModal,
    removedDevicesResponse,
    isLoading,
    numberOfUsers,
    secondaryEmails,
    newSecondaryEmail,
    secondaryEmailError,
    mergedDevices,
    editingIndex,
    editingEmail,
    setEditingEmail,
    handleSaveEditSecondaryEmail,
    handleCancelEditSecondaryEmail,
    setOpenConfirmModal,
    setOpenResultModal,
    handleChange,
    handleNewSecondaryEmailChange,
    handleAddSecondaryEmail,
    handleDeleteSecondaryEmail,
    handleEditSecondaryEmail,
    toggleDeviceSelection,
    onResetPasswordClick,
    handleSubmit,
    resetForm,
    handleYesClick,
    handleNoClick,
    handleResultOk,
  } = hpFormProps;

  return (
    <div className="tab-panel-content patientdetails">
      {isLoading && (
        <div className="loader-container" style={{ zIndex: 1100 }}>
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}

      {isEditingProfile ? (
        <>
          <div className="tab-panel-header">
            <h3>Edit Healthcare Professional Profile</h3>
          </div>
          <div className="hp-form-container_formdetails" style={{ padding: 0 }}>
            <div className="form-section basic-info-section">
              <div className="form-section-header">
                <div className="form-section-header-left">
                  <h4 className="form-section-title">Basic Information</h4>
                  <p className="form-section-subtitle">Provide basic registration details and credentials.</p>
                </div>
              </div>
              <div className="hp-form-container_formdetails_container">
                <HPBasicInfoFields
                  formData={formData}
                  errors={errors}
                  isEditing={true}
                  resetPassword={hpFormProps.resetPassword}
                  onChange={handleChange}
                  onResetPasswordClick={onResetPasswordClick}
                />
              </div>
            </div>

            <hr className="form-divider" style={{ margin: "20px 0", border: "0", borderTop: "1px solid #e8ebee" }} />

            <DeviceAssignmentSection
              mergedDevices={mergedDevices}
              assignDevices={hpFormProps.assignDevices}
              errors={errors}
              formData={formData}
              numberOfUsers={numberOfUsers}
              onToggleDevice={toggleDeviceSelection}
              onChangeDescription={handleChange}
              secondaryEmails={secondaryEmails}
              newSecondaryEmail={newSecondaryEmail}
              secondaryEmailError={secondaryEmailError}
              handleNewSecondaryEmailChange={handleNewSecondaryEmailChange}
              handleAddSecondaryEmail={handleAddSecondaryEmail}
              handleDeleteSecondaryEmail={handleDeleteSecondaryEmail}
              handleEditSecondaryEmail={handleEditSecondaryEmail}
              editingIndex={editingIndex}
              editingEmail={editingEmail}
              setEditingEmail={setEditingEmail}
              handleSaveEditSecondaryEmail={handleSaveEditSecondaryEmail}
              handleCancelEditSecondaryEmail={handleCancelEditSecondaryEmail}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "30px",
                borderTop: "1px solid #eee",
                paddingTop: "20px",
              }}
            >
              <Buttons
                text="Cancel"
                type="button"
                onClick={() => {
                  resetForm();
                  setIsEditingProfile(false);
                }}
                variant="secondary"
                style={{ width: "100px" }}
              />
              <Buttons
                text="Save"
                type="button"
                onClick={() => handleSubmit(() => setIsEditingProfile(false))}
                variant="primary"
                style={{ width: "100px" }}
              />
            </div>
          </div>

          <ConfirmDialog
            open={openConfirmModal}
            onClose={() => setOpenConfirmModal(false)}
            title="Confirm Device Unassignment"
            severity="warning"
            content={messages}
            buttonText="YES"
            additionalButtonText="NO"
            onButtonClick={handleYesClick}
            onAdditionalButtonClick={handleNoClick}
          />

          <ErrorAlert
            open={openResultModal}
            onClose={() => setOpenResultModal(false)}
            content={
              <div>
                <p>{messages}</p>
                {removedDevicesResponse?.length > 0 && (
                  <ul style={{ marginTop: "8px", paddingLeft: "18px" }}>
                    {removedDevicesResponse.map((item) => (
                      <li key={`${item.deviceId}-${item.patientId}`}>
                        <strong>{item.deviceName}</strong>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            }
            buttonText="OK"
            onButtonClick={handleResultOk}
          />
        </>
      ) : (
        <>
          <div className="tab-panel-header">
            <h3>Healthcare Professional Information</h3>
            <div style={{ display: "flex", gap: "10px" }}>
              <Buttons
                text="Edit"
                type="button"
                variant="primary"
                fullWidth={false}
                icon={<EditIcon fontSize="small" />}
                onClick={() => setIsEditingProfile(true)}
              />
              <Buttons
                text="Delete Professional"
                type="button"
                variant="secondary"
                fullWidth={false}
                icon={<DeleteOutlineIcon fontSize="small" />}
                onClick={onDeleteHP}
                style={{ color: "#d32f2f", borderColor: "#d32f2f" }}
              />
            </div>
          </div>
          <HPInfoView formData={formData} secondaryEmails={secondaryEmails} />
        </>
      )}
    </div>
  );
};

export default HPProfileTab;
